import TechHero from "../components/TechHero";
import { CONTACT_INFO } from "../config/constants";

export default function PrivacyPolicy() {
  return (
    <div className="space-y-8 pb-16">
      <TechHero
        kicker="Legal"
        title="Privacy Policy"
        subtitle="How we protect your data and privacy"
      />

      <section className="max-w-4xl mx-auto space-y-6 text-white/90">
        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">1. Introduction</h2>
          <p>
            ZS NEXATECH ("Company", "we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">2. Information We Collect</h2>
          <p className="mb-3">We may collect information about you in a variety of ways:</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li><strong>Personal Data:</strong> Name, email address, phone number provided through contact forms</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time spent on site</li>
            <li><strong>Cookies:</strong> Data stored locally for analytics and user experience improvement</li>
            <li><strong>Project Data:</strong> Information you provide for project quotes or inquiries</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">3. How We Use Your Information</h2>
          <p className="mb-3">We use the information we collect to:</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>Process and respond to your inquiries and requests</li>
            <li>Improve our website and services</li>
            <li>Understand user preferences and behavior</li>
            <li>Send you marketing materials (with your consent)</li>
            <li>Comply with legal obligations</li>
            <li>Prevent fraud and security breaches</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">4. Data Sharing</h2>
          <p>
            We do not sell, rent, or share your personal information with third parties without your consent, except as required by law or for service providers who assist us in operating our website and conducting our business.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">6. Your Rights</h2>
          <p className="mb-3">You have the right to:</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent at any time</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">7. Cookies</h2>
          <p>
            Our website uses cookies to enhance your experience. You can control cookie settings through your browser preferences. Disabling cookies may affect website functionality.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">8. Google Analytics</h2>
          <p>
            We use Google Analytics to understand how visitors interact with our website. Google Analytics collects data about your visits in an anonymized form. You can opt-out by visiting Google's opt-out page or using Google Analytics opt-out browser add-on.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">9. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for their privacy practices. Please review their privacy policies before providing your information.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">10. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or our privacy practices, please contact us at:
          </p>
          <p className="mt-3 font-semibold">
            Email: {CONTACT_INFO.email}<br />
            Phone: {CONTACT_INFO.phone}
          </p>
        </div>

        <div className="pt-4 border-t border-white/20">
          <p className="text-sm text-white/60">
            Last Updated: February 2026. We reserve the right to update this Privacy Policy at any time. Changes will be effective immediately upon posting.
          </p>
        </div>
      </section>
    </div>
  );
}
